import React from "react";
import HeaderNav from "../../header/header";
import {
    Button,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    Layout,
    message,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Table
} from "antd";
import moment from 'moment';
import "../css/SingleCreateFinancialClaim.css"
import {Option} from "antd/es/mentions";
import {dispute_approval_report, dispute_types, downloadAttachment, getAttachment, financial_claim_detail} from "../../../requist";
import ExportJsonExcel from "js-export-excel";

const { Content } = Layout;

class DisputeReport extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            selectedRowKeys:[],
            isModalVisible:false,
            isModalVisible2:false,
            optionList:[],
            region:'WE',
            businessUnit:'P',
            data:[],
            fileName:[],
            fileCategory:[],
            fileId:[],
            disputeNumber:[],
            fileCategoryDesc:[],
            loading:false,
            detailData:null,
        }
        this.columns = [
            {
                title: 'Dispute No',
                dataIndex: 'disputeNo',
                width: 150,
                render:((text)=>{
                    return <a onClick={()=>{
                        getAttachment(text).then(res=>{
                            const {data,retCode,retMsg} = res;
                            if(retCode==="200"){
                                let fileNameList=[];
                                let fileCategoryList=[];
                                let fileCategoryListDesc=[];
                                let fileIdList=[];
                                let disputeNumberList=[];
                                data.map(item=>{
                                    fileNameList.push(item.fileName)
                                    fileCategoryList.push(item.fileCategory)
                                    fileCategoryListDesc.push(item.fileCategoryDesc)
                                    fileIdList.push(item.fileId)
                                    disputeNumberList.push(item.disputeNo)
                                })
                                this.setState({
                                    fileName:fileNameList,
                                    fileCategory:fileCategoryList,
                                    fileCategoryDesc:fileCategoryListDesc,
                                    fileId:fileIdList,
                                    disputeNumber:disputeNumberList,
                                    isModalVisible:true
                                })
                            }else{
                                message.error(`${retMsg}`)
                            }
                        })
                    }
                    }>{text}</a>
                })
            },
            {
                title: 'Dispute Status',
                dataIndex: 'statusText',
                width: 250,
            },
            {
                title: 'Dispute Type',
                dataIndex: 'disputeTypeText',
                width: 180,
            },
            {
                title: 'Dispute Item',
                dataIndex: 'disputeItemNo',
                width: 150,
            },
            {
                title: 'Region',
                dataIndex: 'region',
                width: 100,
            },
            {
                title: 'Business Unit',
                dataIndex: 'businessUnit',
                width: 120,
            },
            {
                title: 'Sold to Number',
                dataIndex: 'soldTo',
                width: 150,
            },
            {
                title: 'Sold to Country',
                dataIndex: 'soldToCountry',
                width: 150,
            },
            {
                title: 'Slas Org',
                dataIndex: 'salesOrg',
                width: 150,
            },
            {
                title: 'Invoice NO',
                dataIndex: 'invoiceNo',
                width: 130,
            },
            {
                title: 'Invoice Item',
                dataIndex: 'invoiceItemNo',
                width: 130,
            },
            {
                title: 'PO',
                dataIndex: 'poNumber',
                width: 150,
            },
            {
                title: 'PN',
                dataIndex: 'partNumber',
                width: 150,
            },
            {
                title: 'Qty',
                dataIndex: 'quantity',
                width: 100,
            },
            {
                title: 'SN',
                dataIndex: 'serialNumbers',
                width: 250,
                render:((text)=>{
                    if(text){
                        if(text.length>3){
                            return text.slice(0,3).join(',')+'...'
                        }else{
                            return text.slice(0,3).join(',')
                        }
                    }
                })
            },
            {
                title: 'Financial Claim SN',
                dataIndex: 'claimSerialNumber',
                width: 250,
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width: 150,
            },
            {
                title: 'Currency',
                dataIndex: 'claimCurrency',
                width: 100,
            },
            {
                title: 'Approve Type',
                dataIndex: 'approveType',
                width: 150,
                render:(text)=>{
                    if(text==="1"){
                        return 'With credit / debit note'
                    }else if (text==="2"){
                        return 'With offline process'
                    }else if (text==="3"){
                        return 'With mass tool'
                    }
                }
            },
            {
                title: 'Claim Analyst Comment',
                dataIndex: 'approveComments',
                width: 250,
            },
            {
                title: 'Claim Request No',
                dataIndex: 'claimReqNo',
                width: 250,
            },
            {
                title: 'Claim ID',
                dataIndex: 'claimId',
                width: 150,
                render:((text,record)=>{
                    return <a onClick={()=>{
                        this.setState({isModalVisible2:true})
                        let params={
                            claimId:text,
                            claimReqNo:record.claimReqNo
                        }
                        financial_claim_detail(params).then(res=>{
                            const {retCode,retMsg,data} = res;
                            if(retCode==='200'){
                                this.setState({detailData:data})
                            }else{
                                message.error(`${retMsg}`)
                            }
                        })
                    }
                    }>{text}</a>
                })
            },
            {
                title: 'Claim Item No',
                dataIndex: 'claimItemNo',
                width: 150,
            },
            {
                title: 'RMA number',
                dataIndex: 'soNumber',
                width: 150,
            },
            {
                title: 'Credit/Debit Note',
                dataIndex: 'billingNo',
                width: 150,
            },
            {
                title: 'Mass Upload ',
                dataIndex: 'massUpload',
                width: 130,
            },
            {
                title: 'Requestor ID',
                dataIndex: 'requesterId',
                width: 150,
            },
            {
                title: 'Create At',
                dataIndex: 'createdAt',
                width: 150,
            },
        ];
        this.columns1=[
            {
                title: 'Dispute No',
                dataIndex: 'disputeNo',
                width: 150,
                render:((text)=>{
                    return <a onClick={()=>{
                        getAttachment(text).then(res=>{
                            const {data,retCode,retMsg} = res;
                            if(retCode==="200"){
                                let fileNameList=[];
                                let fileCategoryList=[];
                                let fileCategoryListDesc=[];
                                let fileIdList=[];
                                let disputeNumberList=[];
                                data.map(item=>{
                                    fileNameList.push(item.fileName)
                                    fileCategoryList.push(item.fileCategory)
                                    fileCategoryListDesc.push(item.fileCategoryDesc)
                                    fileIdList.push(item.fileId)
                                    disputeNumberList.push(item.disputeNo)
                                })
                                this.setState({
                                    fileName:fileNameList,
                                    fileCategory:fileCategoryList,
                                    fileCategoryDesc:fileCategoryListDesc,
                                    fileId:fileIdList,
                                    disputeNumber:disputeNumberList,
                                    isModalVisible:true
                                })
                            }else{
                                message.error(`${retMsg}`)
                            }
                        })
                    }
                    }>{text}</a>
                })
            },
            {
                title: 'Dispute Status',
                dataIndex: 'statusText',
                width: 250,
            },
            {
                title: 'Dispute Type',
                dataIndex: 'disputeTypeText',
                width: 180,
            },
            {
                title: 'Dispute Item',
                dataIndex: 'disputeItemNo',
                width: 150,
            },
            {
                title: 'Region',
                dataIndex: 'region',
                width: 100,
            },
            {
                title: 'Business Unit',
                dataIndex: 'businessUnit',
                width: 120,
            },
            {
                title: 'Sold to Number',
                dataIndex: 'soldTo',
                width: 150,
            },
            {
                title: 'Sold to Country',
                dataIndex: 'soldToCountry',
                width: 150,
            },
            {
                title: 'Slas Org',
                dataIndex: 'salesOrg',
                width: 150,
            },
            {
                title: 'Invoice NO',
                dataIndex: 'invoiceNo',
                width: 150,
            },
            {
                title: 'Invoice Item',
                dataIndex: 'invoiceItemNo',
                width: 130,
            },
            {
                title: 'PO',
                dataIndex: 'poNumber',
                width: 150,
            },
            {
                title: 'PN',
                dataIndex: 'partNumber',
                width: 150,
            },
            {
                title: 'Qty',
                dataIndex: 'quantity',
                width: 100,
            },
            {
                title: 'SN',
                dataIndex: 'serialNumbers',
                width: 250,
                render:((text)=>{
                    if(text){
                        if(text.length>3){
                            return text.slice(0,3).join(',')+'...'
                        }else{
                            return text.slice(0,3).join(',')
                        }
                    }
                })
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width: 150,
            },
            {
                title: 'Currency',
                dataIndex: 'claimCurrency',
                width: 100,
            },
            {
                title: 'Credit Order Number',
                dataIndex: 'soNumber',
                width: 150,
            },
            {
                title: 'Credit/Debit Note',
                dataIndex: 'billingNo',
                width: 150,
            },
            {
                title: 'Requestor ID',
                dataIndex: 'requesterId',
                width: 150,
            },
            {
                title: 'Create At',
                dataIndex: 'createdAt',
                width: 150,
            },
        ]
        this.columnsItem=[
            {
                title: 'Claim Item No',
                dataIndex: 'claimReqItem',
                width: 250,
            },
            {
                title: 'Material',
                dataIndex: 'partNumber',
                width: 250,
            },
            {
                title: 'Message',
                dataIndex: 'message',
                width: 250,
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                width: 250,
            },
            {
                title: 'End User Name',
                dataIndex: 'endUserName',
                width: 250,
            },
            {
                title: 'Unit Claim Value',
                dataIndex: 'unitClaimValue',
                width: 250,
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width: 250,
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNumber',
                width: 250,
            },
            {
                title: 'Status',
                dataIndex: 'status',
                width: 250,
            },
            {
                title: 'SO Number',
                dataIndex: 'soNumber',
                width: 250,
            },
            {
                title: 'Delivery Number',
                dataIndex: 'deliveryNumber',
                width: 250,
            },
            {
                title: 'Billing Number',
                dataIndex: 'billingNo',
                width: 250,
            },
            {
                title: 'Processing Log',
                dataIndex: 'processingLog',
                width: 250,
            },
            {
                title: 'Deletion Indicator',
                dataIndex: 'deleteStatus',
                width: 250,
            },
        ]
    }
    onRegionChange=(value)=>{
        let we_dispute_types=[]
        const { businessUnit } = this.state;
        dispute_types().then((res)=>{
            res.data.map((item)=>{
                if(item.region===value && item.businessUnit===businessUnit){
                    we_dispute_types.push(item)
                }
            })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({region:value,optionList:we_dispute_types})
        })
    }
    onBusinessUnitChange=(value)=>{
        let we_dispute_types=[]
        const { region } = this.state;
        dispute_types().then((res)=>{
            res.data.map((item)=>{
                if(item.region===region && item.businessUnit===value){
                    we_dispute_types.push(item)
                }
            })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({businessUnit:value,optionList:we_dispute_types})
        })
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    componentDidMount() {
        let we_dispute_types=[]
        dispute_types().then((res)=>{
            // res.data.map((item)=>{
            //     if(item.region=='WE' && item.businessUnit=='P'){
            //         we_dispute_types.push(item)
            //     }
            // })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({optionList:we_dispute_types})
        })
    }
    downloadExcel = () => {
        let userType = window.localStorage.getItem('userType')
        const data = this.state.data ? this.state.data : [];//表格数据
        var option={};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if(data){
                    // console.log(data)
                    if(data[i].approveType==="1"){
                        data[i].approveType='With credit / debit note'
                    }else if(data[i].approveType==="2"){
                        data[i].approveType='With offline process'
                    }else if(data[i].approveType==="3"){
                        data[i].approveType='With mass tool'
                    }
                    let obj
                    if(userType==='external'){
                        obj = {
                            'Dispute ID': data[i].disputeNo,
                            'Dispute Status': data[i].statusText,
                            'Dispute Type': data[i].disputeTypeText,
                            'Customer Internal Reference': data[i].customerInternalRef,//1
                            'Approved By': data[i].approvedBy,
                            'Approved Date': data[i].approvedAt,
                            'Claim Analyst Comment': data[i].approveComments,
                            'Invoice': data[i].invoiceNo,
                            'PO': data[i].poNumber,
                            'PN': data[i].partNumber,
                            'SN': data[i].serialNumbers,
                            'Created At': data[i].createdAt,
                            'Requestor': data[i].requesterId,
                            'Requestor Email': data[i].requesterEmail,  //1
                            'Contact Person Email Address': data[i].contactPersonEmail, //1
                            'Claim Value': data[i].claimValue,
                            'Currency': data[i].claimCurrency,
                            'RMA number': data[i].soNumber,
                            'Credit/Debit Note': data[i].billingNo,
                        }
                    }else{
                        obj = {
                            'Dispute ID': data[i].disputeNo,
                            'Dispute Status': data[i].statusText,
                            'Dispute Type': data[i].disputeTypeText,
                            'Dispute Item': data[i].disputeItemNo,
                            'Region': data[i].region,
                            'Market': data[i].market,
                            'Business Unit': data[i].businessUnit,
                            'Sold To Number': data[i].soldTo,
                            'Sold To Name': data[i].soldToName,
                            'Bill To Number': data[i].billTo,
                            'Bill To Name': data[i].billToName,
                            'Ship To Number': data[i].shipTo,
                            'Ship To Name': data[i].shipToName,
                            'Sales Org': data[i].salesOrg,
                            'Service Epack type': data[i].epackType,
                            'Service Claim Desc': data[i].claimDescription,
                            // 'approveType':data[i].approveType,
                            'Comments': data[i].comments,
                            'Text To Appear On Credit Note': data[i].creditNote,
                            'Reason Description': data[i].reasonDescription,
                            'Customer Internal Reference': data[i].customerInternalRef,//1
                            'Requested VAT ID': data[i].requestVatId, //1
                            'Requested Changes': data[i].requestedChanges, //1
                            'Credit Amount Total': data[i].creditAmountTotal,
                            'Approved By': data[i].approvedBy,
                            'Approved Date': data[i].approvedAt,
                            'Approve Type': data[i].approveType,
                            'Claim Analyst Comments': data[i].approveComments,
                            'Invoice': data[i].invoiceNo,
                            'Invoice Item': data[i].invoiceItemNo,
                            'PO': data[i].poNumber,
                            'PN': data[i].partNumber,
                            'Qty': data[i].quantity,
                            'SN': data[i].serialNumbers,
                            'Item Amount': data[i].creditAmountTotal,
                            'Item unit Amount': data[i].creditAmountUnit,
                            'Dispute Currency': data[i].currency,
                            'Order Number': data[i].orderNumber,
                            'Order Item Number': data[i].orderItemNo,
                            'Delivery Number': data[i].deliveryNumber,
                            'Delivery Item no': data[i].deliveryItemNo,
                            'Contract Number': data[i].contractNumber,
                            'Price Drop Date': data[i].priceDropDate,
                            'Service Period Start Date': data[i].serviceStartDate,
                            'Service Period End Date': data[i].serviceEndDate,
                            'BIOS Password': data[i].biosPassword,
                            'DOA Period Confirmation Number': data[i].doaConfirmNo,
                            'Backend Disbursement Type': data[i].backendType,
                            'GI Agreement No': data[i].bdpGiNo,
                            'Backend Period/Quarter': data[i].period,
                            'Created At': data[i].createdAt,
                            'Requestor': data[i].requesterId,
                            'Requestor Email': data[i].requesterEmail,  //1
                            'Requestor Country': data[i].requesterCountry,
                            'Requestor Phone Number': data[i].requesterPhoneNo, //1
                            'Contact Person': data[i].contactPerson,
                            'Contact Person Country': data[i].contactPersonCountry, //1
                            'Contact Person Email Address': data[i].contactPersonEmail, //1
                            'Contact Person Phone Number': data[i].contactPersonPhone, //1
                            'Contact Person Company': data[i].contactPersonCompany, //1
                            'Contact Person Street': data[i].contactPersonStreet, //1
                            'Contact Person Zip Code': data[i].contactPersonZipCode, //1
                            'Contact Person City/SKID': data[i].contactPersonCity, //1
                            'Dispute Created date': data[i].createdAt, //1
                            'Dispute Created by': data[i].createdBy, //1
                            'Dispute Changed date': data[i].changedAt, //1
                            'Dispute Changed by': data[i].changedBy, //1
                            'Financial Claim Type': data[i].claimType,
                            'Financial Claim Category': data[i].claimCategory,
                            'Financial Claim Sales Org': data[i].salesOrg,
                            'Financial Claim Channel': data[i].channel,
                            'Financial Claim Sales Office': data[i].salesOffice,
                            'Claim Value': data[i].claimValue,
                            'Currency': data[i].claimCurrency,
                            'Claim Req No': data[i].claimReqNo,
                            'Claim ID': data[i].claimId,
                            'Claim Item No': data[i].claimItemNo, //1
                            'Financial Claim Pricing Date': data[i].pricingDate,
                            'Req Delivery Date': data[i].reqDeliveryDate,
                            'Lenovo Ref': data[i].lenovoRef,
                            'BP Ref': data[i].bpRef,
                            'Claim Contact Country': data[i].country,
                            'Claim Contact Postal Code': data[i].postalCode,
                            'Claim Contact Street': data[i].street,
                            'Claim Contact Street2': data[i].street2,
                            'Contact City': data[i].city,
                            'Claim Contact Person': data[i].ClaimContactPerson,
                            'Claim Contact Phone No': data[i].phoneNo,
                            'Claim Contact Email': data[i].email,
                            'Claim Comments': data[i].claimComments,
                            'Billing_Instructions': data[i].billingInstruction,
                            'Claim Req Status': data[i].claimStatusText,
                            'Financial Record Approve Date': data[i].approvedAt,
                            'Financial Record Approve By': data[i].approvedBy,
                            'RMA number': data[i].soNumber,
                            'Claim Order Item': data[i].soItemNo,
                            'Claim Order Created Date': data[i].orderCreatedAt,
                            'Credit/Debit Note': data[i].billingNo,
                            'Cmr Order No':data[i].cmrOrderNo,
                            'Mass Upload': data[i].massUpload,
                            'ECC Processing Log': data[i].processingLog,
                            'ECC Delete Flag': data[i].deleteStatus,
                            'Payment term': data[i].paymentTerm,
                            'Claim Reference No': data[i].claimRefNo,
                            'End User Name': data[i].endUserName,
                            'Serial Number': data[i].serialNumber,
                            'CBSO Flag': data[i].cbsoFlag,
                            'Claim Machine Type': data[i].machine,
                            'CBSO Contract No': data[i].contractNo,
                            'CBSO Contract Start Date': data[i].contractStartDate,
                            'CBSO Contract End Date': data[i].contractEndDate,
                            'CBSO Billing Start Date': data[i].billingStartDate,
                            'CBSO Billing End Date': data[i].billingEndDate,
                            'CBSO Billing Frequency': data[i].billingFrequency,
                            'CBSO Header Text': data[i].headerText,
                            'CBSO Asset Location': data[i].assetLocation,
                            'CBSO SLA': data[i].sla,
                            'Financial Record Created Date': data[i].portalCreatedAt,
                            'Financial Record Created By': data[i].portalCreatedBy,
                            'Financial Record Changed Date': data[i].portalChangedAt,
                            'Financial Record Changed By': data[i].portalChangedBy,

                        }
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'Dispute_Status_Report'
        if(userType==='external'){
            option.datas=[
                {
                    sheetData:dataTable,
                    sheetName:'sheet',
                    // sheetFilter:['portalReqNo'],
                    sheetHeader:[
                        'Dispute ID',
                        'Dispute Status',
                        'Dispute Type',
                        'Customer Internal Reference',
                        'Approved By',
                        'Approved Date',
                        'Claim Analyst Comment',
                        'Invoice',
                        'PO',
                        'PN',
                        'SN',
                        'Created At',
                        'Requestor',
                        'Requestor Email',
                        'Contact Person Email Address',
                        'Claim Value',
                        'Currency',
                        'RMA number',
                        'Credit/Debit Note',
                    ],
                }
            ];
        }else{
            option.datas=[
                {
                    sheetData:dataTable,
                    sheetName:'sheet',
                    // sheetFilter:['portalReqNo'],
                    sheetHeader:[
                        'Dispute ID','Dispute Status','Dispute Type','Dispute Item',
                        'Region','Market','Business Unit','Sold To Number','Sold To Name',
                        'Bill To Number','Bill To Name','Ship To Number','Ship To Name',
                        'Sales Org','Service Epack type','Service Claim Desc','Comments',
                        'Text To Appear On Credit Note','Reason Description',
                        'Customer Internal Reference','Requested VAT ID','Requested Changes','Credit Amount Total',
                        'Approved By','Approved Date','Approval Type',
                        'Claim Analyst Comments','Invoice','Invoice Item','PO','PN','Qty','SN',
                        'Item Amount','Item unit Amount','Dispute Currency','Order Number','Order Item Number','Delivery Number',
                        'Delivery Item no','Contract Number','Price Drop Date','Service Period Start Date',
                        'Service Period End Date','BIOS Password','DOA Period Confirmation Number',
                        'Backend Disbursement Type','GI Agreement No','Backend Period/Quarter',
                        'Created At','Requestor','Requestor Email','Requestor Country',
                        'Requestor Phone Number','Contact Person','Contact Person Country',
                        'Contact Person Email Address','Contact Person Phone Number',
                        'Contact Person Company','Contact Person Street','Contact Person Zip Code',
                        'Contact Person City/SKID','Dispute Created date','Dispute Created by',
                        'Dispute Changed date','Dispute Changed by','Financial Claim Type',
                        'Financial Claim Category','Financial Claim Sales Org','Financial Claim Channel',
                        'Financial Claim Sales Office','Claim Value','Currency','Claim Req No','Claim ID',
                        'Claim Item No','Financial Claim Pricing Date','Req Delivery Date',
                        'Lenovo Ref','BP Ref','Claim Contact Country','Claim Contact Postal Code','Claim Contact Street',
                        'Claim Contact Street2','Claim Contact City','Claim Claim Contact Person','Claim Contact Phone No',
                        'Claim Contact Email','Claim Comments', 'Billing_Instructions','Claim Req Status','Financial Record Approve Date',
                        'Financial Record Approve By','RMA number','Claim Order Item',
                        'Claim Order Created Date','Credit/Debit Note','Cmr Order No','Mass Upload','ECC Processing Log','ECC Delete Flag',
                        'Payment term','Claim Reference No','End User Name','Serial Number','CBSO Flag',
                        'Claim Machine Type','CBSO Contract No','CBSO Contract Start Date',
                        'CBSO Contract End Date','CBSO Billing Start Date','CBSO Billing End Date',
                        'CBSO Billing Frequency','CBSO Header Text','CBSO Asset Location',
                        'CBSO SLA','Financial Record Created Date','Financial Record Created By',
                        'Financial Record Changed Date','Financial Record Changed By'

                    ],
                }
            ];
        }
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
    }
    onFinish=(values)=>{
        this.setState({data:[],loading:true})
        if (!Array.isArray(values.disputeNo)) {
            values.disputeNo = values.disputeNo ? values.disputeNo.split(',') : undefined;
        }
        if (!Array.isArray(values.invoiceNo)) {
            values.invoiceNo = values.invoiceNo ? values.invoiceNo.split(',') : undefined;
        }
        if (!Array.isArray(values.soldToCountry)) {
            values.soldToCountry = values.soldToCountry ? values.soldToCountry.split(',') : undefined;
        }
        if (!Array.isArray(values.soldTo)) {
            values.soldToList = values.soldTo ? values.soldTo.split(',') : undefined;
        } else {
            values.soldToList = values.soldTo;
        }
        values.soldTo = null;
        if(values.disputeType){
            if(values.disputeType==='ALL'){
                values.disputeType=undefined
            }else{
                values.disputeType.map(item=>{
                    if(item=="ALL"){
                        values.disputeType=undefined
                    }
                })
            }
        }
        let params={
            ...values,
            region: values.region==="ALL"?undefined:values.region,
            businessUnit: values.businessUnit==="ALL"?undefined:values.businessUnit,
            createdOnFrom: values.createdOnFrom ? moment(values.createdOnFrom).format('YYYY-MM-DD') + ' 00:00:00' : undefined,
            createdOnTo:values.createdOnTo ? moment(values.createdOnTo).format('YYYY-MM-DD') + ' 23:59:59' : undefined,
        }
        dispute_approval_report(params).then((res)=>{
            if(res.retCode==='200'){
                this.setState({data:res.data,loading:false})
            }else{
                this.setState({loading:false})
                message.warn(`${res.retMsg}`)
            }
        })
    }
    handleOk=()=>{
        this.setState({isModalVisible:false})
    }
    handleCancel=()=>{
        this.setState({isModalVisible:false})
    }
    handleOk2=()=>{
        this.setState({isModalVisible2:false})
    }
    handleCancel2=()=>{
        this.setState({isModalVisible2:false})
    }
    downloadAttachmentFile=(e)=>{
        let params = e.target.innerHTML;
        downloadAttachment(params).then(res=>{
            let URL = window.URL || window.webkitURL;
            let objectUrl = URL.createObjectURL(res);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.download = params;
            document.body.appendChild(a);
            a.click();
            a.remove();
        })
    }


    dpSplit=(e,name)=>{
        let value = e.target.value
        if (value.indexOf(" ") == -1) {

        } else {
            if(value){
                const obj ={}
                obj[name] = value.trim().split(/\s+/)
                this.formRef.current.setFieldsValue(obj)
            }
        }
    }
    render() {
        let userType = window.localStorage.getItem('userType')
        const { data,isModalVisible,fileCategory,fileId,fileName,disputeNumber,fileCategoryDesc,loading,detailData, isModalVisible2 } = this.state;
        return <div>
            <HeaderNav parmas={'/disputeReport'}/>
            <Layout className="site-layout-background singleFinancialClaimEdit" style={{ padding: '24px 0' }}>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    {detailData && <Modal title="Financial Claim Detail"
                                          width={1500}
                                          visible={isModalVisible2}
                                          onOk={this.handleOk2}
                                          onCancel={this.handleCancel2}
                                          destroyOnClose={true}
                    >
                        <Form
                            name="FinancialClaimDetail"
                            labelCol={{span: 15}}
                            wrapperCol={{span: 10}}
                            preserve={false}
                        >
                            <Row>
                                <Col span={8}>
                                    <Form.Item
                                        label="Dispute Number"
                                        name="billingInstruction"
                                    >
                                        <span>{`${detailData[0].billingInstruction}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Request No"
                                        name="claimReqNo"
                                    >
                                        <span>{`${detailData[0].claimReqNo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim ID"
                                        name="claimId"
                                    >
                                        <span>{`${detailData[0].claimId}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Invoice No"
                                        name="invoiceNo"
                                    >
                                        <span>{`${detailData[0].invoiceNo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sold to Party"
                                        name="soldTo"
                                    >
                                        <span>{`${detailData[0].soldTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Bill to Party"
                                        name="billTo"
                                    >
                                        <span>{`${detailData[0].billTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Category"
                                        name="claimCategory"
                                    >
                                        <span>{`${detailData[0].claimCategory}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Pricing Date"
                                        name="pricingDate"
                                    >
                                        <span>{`${detailData[0].pricingDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Requested Delivery Date"
                                        name="reqDeliveryDate"
                                    >
                                        <span>{`${detailData[0].reqDeliveryDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sales Org"
                                        name="salesOrg"
                                    >
                                        <span>{`${detailData[0].salesOrg}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Currency"
                                        name="currency"
                                    >
                                        <span>{`${detailData[0].currency}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Purchase Order Number"
                                        name="poNumber"
                                    >
                                        <span>{`${detailData[0].poNumber}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Sales Office"
                                        name="salesOffice"
                                    >
                                        <span>{`${detailData[0].salesOffice}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="SBO-No/ SOP Ref. /Lenovo Ref"
                                        name="lenovoRef"
                                    >
                                        <span>{`${detailData[0].lenovoRef}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Channel"
                                        name="channel"
                                    >
                                        <span>{`${detailData[0].channel}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="BP-Reference"
                                        name="bpRef"
                                    >
                                        <span>{`${detailData[0].bpRef}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Country"
                                        name="country"
                                    >
                                        <span>{`${detailData[0].country}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Claim Type"
                                        name="claimType"
                                    >
                                        <span>{`${detailData[0].claimType}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Street/ House No"
                                        name="street"
                                    >
                                        <span>{`${detailData[0].street}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Street 2"
                                        name="street2"
                                    >
                                        <span>{`${detailData[0].street2}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Ship to Party"
                                        name="shipTo"
                                    >
                                        <span>{`${detailData[0].shipTo}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Postal Code"
                                        name="postalCode"
                                    >
                                        <span>{`${detailData[0].postalCode}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="City"
                                        name="city"
                                    >
                                        <span>{`${detailData[0].city}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Contact Person"
                                        name="contactPerson"
                                    >
                                        <span>{`${detailData[0].contactPerson}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                    >
                                        <span>{`${detailData[0].email}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Phone number"
                                        name="phoneNumber"
                                    >
                                        <span>{`${detailData[0].phoneNumber}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Comment"
                                        name="comment"
                                    >
                                        <span>{`${detailData[0].comment}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Billing Instruction"
                                        name="billingInstruction"
                                    >
                                        <span>{`${detailData[0].billingInstruction}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created Date"
                                        name="createdOn"
                                    >
                                        <span>{`${detailData[0].createdOn}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created Time"
                                        name="createdTime"
                                    >
                                        <span>{`${detailData[0].createdTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Created By"
                                        name="createdBy"
                                    >
                                        <span>{`${detailData[0].createdBy}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved Date"
                                        name="approvedAt"
                                    >
                                        <span>{`${detailData[0].approvedAt}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved Time"
                                        name="approveTime"
                                    >
                                        <span>{`${detailData[0].approveTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Approved By"
                                        name="approvedBy"
                                    >
                                        <span>{`${detailData[0].approvedBy}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed Date"
                                        name="changeDate"
                                    >
                                        <span>{`${detailData[0].changeDate}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed Time"
                                        name="changedTime"
                                    >
                                        <span>{`${detailData[0].changedTime}`}</span>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Changed By"
                                        name="changedBy"
                                    >
                                        <span>{`${detailData[0].changedBy}`}</span>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item style={{textAlign: 'right'}}>
                            </Form.Item>
                            <div style={{margin: '0 auto'}}>
                                <h1>Claim Item</h1>
                                <Table
                                    scroll={{y: 500}}
                                    columns={this.columnsItem}
                                    rowKey={'claimId'}
                                    dataSource={detailData}
                                    bordered
                                />
                            </div>
                        </Form>
                    </Modal>}
                    <Modal title="Dispute Attachment Download"
                           width={1200}
                           visible={isModalVisible}
                           onOk={this.handleOk}
                           onCancel={this.handleCancel}
                           destroyOnClose={true}
                    >
                        <Row>
                            <Col span={10}>
                                <h1>File Category</h1>
                                {fileCategoryDesc.map((item,index)=>{
                                    if (fileCategory[index] === 'APPAT' && userType === 'external') {
                                        return;
                                    }
                                    return <Form.Item
                                        label={item}
                                        name={item}
                                    >
                                    </Form.Item>
                                })}
                            </Col>
                            <Col span={10}>
                                <h1>File Name</h1>
                                {disputeNumber.map((item,index)=>{
                                    if (fileCategory[index] === 'APPAT' && userType === 'external') {
                                        return;
                                    }
                                    return <Form.Item
                                        label={''}
                                        name={item}
                                    >
                                        <a style={{display:'block'}} onClick={this.downloadAttachmentFile}>{item+'_'+fileCategory[index]+fileId[index]+'_'+fileName[index]}</a>
                                    </Form.Item>;
                                })}
                            </Col>
                        </Row>
                    </Modal>
                    <h1>Dispute Status Report</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        wrapperCol={{ span: 12}}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Region"
                                    name="region"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select onChange={this.onRegionChange}>
                                        <Option value={'WE'}>WE</Option>
                                        <Option value={'EM'}>EM</Option>
                                        <Option value={'ALL'}>ALL</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="PCG/DCG"
                                    name="businessUnit"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select onChange={this.onBusinessUnitChange}>
                                        <Option value={'P'}>PCG</Option>
                                        <Option value={'D'}>DCG</Option>
                                        <Option value={'ALL'}>ALL</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Type"
                                    name="disputeType"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder="Please select"
                                        style={{ width: '100%' }}
                                        dropdownMatchSelectWidth={240}
                                    >
                                        {
                                            this.state.optionList.map((item)=>{
                                                return <Option value={item.disputeType} >{item.disputeTypeText}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute No"
                                    name="disputeNo"
                                    tooltip={'Dispute No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'disputeNo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create From"
                                    name="createdOnFrom"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date()).subtract(1,"month")}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create To"
                                    name="createdOnTo"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice Number"
                                    name="invoiceNo"
                                    tooltip={'Invoice No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'invoiceNo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to"
                                    name="soldTo"
                                    tooltip={'Sold to can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'soldTo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Status"
                                    name="status"
                                    rules={[{ required: false }]}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder="Please select"
                                        style={{ width: '100%' }}
                                    >
                                        <Option value={'DWAAP'}>Waiting for dispute initial approval</Option>
                                        <Option value={'DWFOA'}>Waiting for dispute offline approval</Option>
                                        <Option value={'DAPPR'}>Dispute approved</Option>
                                        <Option value={'DREJE'}>Dispute rejected</Option>
                                        <Option value={'DCLOS'}>Dispute Billed</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Country"
                                    name="soldToCountry"
                                    tooltip={'Sold to Country can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'soldToCountry')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Requested Changes"
                                    name="requestedChanges"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Request VAT ID"
                                    name="requestVatId"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            {/*<Col span={16}>*/}
                            {/*    <Form.Item*/}
                            {/*        label="Switch on Dispute Item Detail for Mass Tool"*/}
                            {/*        name="switchForItem"*/}
                            {/*        rules={[{ required: false }]}*/}
                            {/*        valuePropName={'checked'}*/}
                            {/*    >*/}
                            {/*        <Checkbox />*/}
                            {/*    </Form.Item>*/}
                            {/*</Col>*/}
                        </Row>
                        <Button style={{marginTop:20,marginBottom:20,float:'right'}} type="primary" htmlType="submit">
                            Search
                        </Button>
                    </Form>
                    <Button style={{marginTop:20}}
                            onClick={data.length?this.downloadExcel:null}
                            type="primary">
                        Export
                    </Button>
                    <Table
                        rowKey={'id'}
                        scroll={{y: 500}}
                        columns={userType==='external'?this.columns1:this.columns}
                        dataSource={data}
                        bordered
                    />
                </Content>
            </Layout>
        </div>
    }
}

export default DisputeReport;